class Request {
    static getParam (key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }
    static isPathFoundInUrl(path) {
        return window.location.href.indexOf(path) > -1;
    }
}

export default Request;